/**
 * 厂家管理
 * **/

const venderApi = {
  //获取列表
  getList: '/ProCompany/GetList',
  //获取信息
  getInfo: '/ProCompany/GetInfo',
  //添加
  add: '/ProCompany/Add',
  //修改
  edit: '/ProCompany/Edit',
  //删除
  delete: '/ProCompany/Del',
}

export default venderApi
